// extracted by mini-css-extract-plugin
module.exports = {"mainMenuHeader":"MainMenuHeader_mainMenuHeader__2ibLh","appIcon":"MainMenuHeader_appIcon__3yrXf","text":"MainMenuHeader_text__2slWM"};